import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

@Pipe({
    name: 'isValueEmpty',
    standalone: true
})
export class IsEmptyPipe implements PipeTransform {
    transform(value: unknown): boolean {
        return isEmpty(value);
    }
}
